import { InternalUploadFile } from "antd/es/upload/interface"

export type UploadFile = Omit<InternalUploadFile, "originFileObj">

export enum UploadStatus {
  UPLOADING = "uploading",
  DONE = "done",
  ERROR = "error",
}
